module.exports = __webpack_public_path__ + "static/media/371.551fcaae.svg";